module.exports = __webpack_public_path__ + "img/slider_galery_3.2a2661bf.jpg";